import { adminApiRequest } from "../../utils/apiUtils";

export interface SearchBannerRequest {
  title: string;
  subTitle: string;
  url: string;
  startAt: string;
  closeAt: string;
  type: string;
  order: number;
}

export const SearchBannerAPI = {
  getSearchBannerList: () => {
    return adminApiRequest.get("/search-banner").then((res) => res);
  },

  createSearchBanner: (body: SearchBannerRequest) => {
    return adminApiRequest.post("/search-banner", body).then((res) => res);
  },

  updateSearchBanner: (id: number, body: SearchBannerRequest) => {
    return adminApiRequest.put(`/search-banner/${id}`, body).then((res) => res);
  },

  deleteSearchBanner: (id: number) => {
    return adminApiRequest.delete(`/search-banner/${id}`).then((res) => res);
  },
};
